"use strict";

angular.module("customer")
.controller("QuantityModalController", function($scope, $attrs, close) {
    var quantities = [];
    const DEFAULT_MAXIMUM_QUANTITY = 100;

    $scope.quantities = quantities;
    $scope.originalQuantity = $attrs.originalQuantity;
    $scope.customValue = $scope.originalQuantity;
    $scope.quantityChoiceCount = DEFAULT_MAXIMUM_QUANTITY;
    $scope.packagingQuantity = $attrs.packagingQuantity || 1;

    for (var i = 0; i <= $scope.quantityChoiceCount * $scope.packagingQuantity; i+=$scope.packagingQuantity) {
        quantities.push(i);
    }

    $scope.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    $scope.cancel = function() {
        $scope.close($scope.originalQuantity);
    };

    $scope.setQuantity = function(quantity) {
        //close set the result value
        $scope.quantity = parseFloat(quantity);
        $scope.close($scope.quantity);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/inventory/modals/inventory-quantity.modal.js
// module id = 795
// module chunks = 0